import styled from "styled-components";

const styles = {
  DivContainer: styled.div`
    width: 100%;
    height: calc(100vh - 70px);
    display: flex;
    flex-direction: column;
    background-color: #f7f9fc;
    position: relative;
    box-sizing: border-box;

    /* Google Maps InfoWindow Customization Overrides */
    .gm-style-iw {
      padding: 0 !important;
      max-height: none !important;
      overflow: hidden !important;
      border-radius: 8px !important;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
    }
    
    .gm-style-iw-d {
      padding: 0 !important;
      max-height: none !important;
      overflow: hidden !important;
    }

    .gm-style-iw-c {
      padding: 0 !important;
      border-radius: 8px !important;
    }

    .gm-ui-hover-effect {
      top: 4px !important;
      right: 4px !important;
      background: rgba(255, 255, 255, 0.8) !important;
      border-radius: 50% !important;
      width: 24px !important;
      height: 24px !important;
      display: grid !important;
      place-items: center !important;
      z-index: 1000 !important;
      
      > span {
        margin: 0 !important;
      }
    }
  `,

  Header: styled.div`
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    background-color: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    z-index: 10;
    box-sizing: border-box;

    .title {
      font-size: 16px;
      font-weight: 600;
      color: #1a202c;
      letter-spacing: -0.01em;
      font-family: 'Roboto', 'Inter', sans-serif;
    }

    .stats {
      display: flex;
      align-items: center;
      gap: 12px;

      .stat-item {
        background-color: #f8fafc;
        border: 1px solid #e2e8f0;
        padding: 6px 14px;
        border-radius: 9999px;
        font-size: 12px;
        font-weight: 500;
        color: #4a5568;
        display: flex;
        align-items: center;
        gap: 6px;
        font-family: 'Roboto', sans-serif;
        
        strong {
          font-weight: 700;
          color: #1a202c;
        }

        &.waiting {
          background-color: #fff5f5;
          border-color: #fed7d7;
          color: #c53030;
          strong {
            color: #9b2c2c;
          }
        }

        &.active {
          background-color: #f0fff4;
          border-color: #c6f6d5;
          color: #22543d;
          strong {
            color: #2f855a;
          }
        }
      }

      .btn-toggle {
        background-color: #ffffff;
        border: 1px solid #cbd5e0;
        color: #4a5568;
        padding: 6px 14px;
        border-radius: 9999px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.15s ease-in-out;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        font-family: 'Roboto', sans-serif;

        &:hover {
          background-color: #f8fafc;
          border-color: #a0aec0;
          color: #2d3748;
        }

        &.active {
          background-color: #13131d;
          border-color: #13131d;
          color: #ffffff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
      }
    }
  `,

  MapWrapper: styled.div`
    width: 100%;
    position: relative;
  `,

  CustomInfoWindow: styled.div`
    padding: 0;
    margin: 0;
    min-width: 260px;
    max-width: 320px;
    width: 280px; /* Fixed width to prevent auto-resizing horizontal scrollbars */
    font-family: 'Roboto', 'Inter', sans-serif;
    color: #2d3748;
    overflow: hidden;

    .info-header {
      margin-bottom: 8px;
      padding: 12px 35px 10px 12px; /* 35px right padding to clear the absolute close button */
      background-color: #f8fafc;
      border-bottom: 1px solid #edf2f7;
    }

    .info-title {
      font-size: 16px;
      font-weight: 700;
      color: #1a202c;
      margin: 0;
    }

    .info-subtitle {
      font-size: 11px;
      font-weight: 600;
      color: #a0aec0;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-top: 2px;
      margin-bottom: 0;
    }

    .info-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      padding: 6px 12px;
      border-bottom: 1px dashed #edf2f7;
      
      &:last-child {
        border-bottom: none;
      }
      
      .label {
        color: #718096;
        font-weight: 500;
      }
      
      .value {
        font-weight: 600;
        color: #2d3748;
        text-align: right;
        word-break: break-all;
        margin-left: 8px;
      }
    }

    .badge {
      display: inline-block;
      padding: 2px 8px;
      border-radius: 20px;
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
    }

    .badge-free {
      background-color: #c6f6d5;
      color: #22543d;
      border: 1px solid #9ae6b4;
    }

    .badge-trip {
      background-color: #feebc8;
      color: #744210;
      border: 1px solid #fbd38d;
    }

    .badge-waiting {
      background-color: #fed7d7;
      color: #742a2a;
      border: 1px solid #feb2b2;
    }

    .section-divider {
      border-top: 1px solid #e2e8f0;
      margin-top: 8px;
      padding: 8px 12px 10px 12px;
    }

    .section-title {
      font-size: 10px;
      color: #718096;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-bottom: 6px;
    }
  `,
};

export default styles;
